import { RefCallback } from 'react';

export const DefaultEdgePadding = '1rem';

export type LimitMaxHeightToScreenOptions = Readonly<{
    /**
     * The default max height to use.  Final max height will be the smaller
     * of `maxHeight` and vertical space available in the browser.
     */
    maxHeight?: string;
    /**
     * Desired amount of padding between vertical edge of content and the
     * edge of the browser (defaults to `'1rem'`).
     */
    edgePadding?: string;
}>;

export function useLimitMaxHeightToScreenRef(
    options?: LimitMaxHeightToScreenOptions
): RefCallback<HTMLDivElement> {
    return (elem: HTMLDivElement | null) => {
        if (!elem) {
            return;
        }

        setTimeout(() => {
            const edgePadding = options?.edgePadding ?? DefaultEdgePadding;
            const bounds = elem.getBoundingClientRect();
            const { style } = elem;
            const isFacingUp = !!style.bottom; // was positioned using style.bottom

            const windowMaxPx = isFacingUp
                ? Math.floor(bounds.bottom)
                : Math.floor(window.innerHeight - bounds.top);

            const finalWindowMax = `calc(${windowMaxPx}px - ${edgePadding})`;

            const finalMaxHeight =
                options?.maxHeight !== undefined
                    ? `min(${finalWindowMax}, ${options.maxHeight})`
                    : finalWindowMax;

            style.maxHeight = finalMaxHeight;
            style.overflowY = 'auto';
        });
    };
}
